import { Card, CardBody, CardTitle, CardSubtitle, ListGroup, ListGroupItem, CardText, Button } from "reactstrap";

const PodiumCard = ({ podium }) => {
    if (!podium) {
        return null;
    }
    return (
        <Card
            color="light"
            body
            className="text-center">
            <CardBody>
                <CardTitle>{podium.name}</CardTitle>
                <CardSubtitle></CardSubtitle>
                <ListGroup>
                    <ListGroupItem>ID: {podium.id}</ListGroupItem>
                    <ListGroupItem>Location ID: {podium.locationId}</ListGroupItem>
                </ListGroup>
            </CardBody>
        </Card>
    );
};

export default PodiumCard;
